<div class="split">
    <div class="left">
        <tree-view [selectedFolder]="selectedFolderStore" [rootLevelStore]="folderRoot"></tree-view>    
    </div>
    <div class="right" *ngIf="mode == 'files'">
          <file-list *ngIf="!searchText?.length" 
            [selectedFolder]="selectedFolderStore"  
            [selectedFiles]="selectedFilesStore" 
            [files]="displayedFilesStore"
         ></file-list>
    </div>
</div>

<div translate class="text-right">
    <button [disabled]="!canPick" (click)="pick()">Pick</button> <button (click)="cnx()">GENERIC.CANCEL</button>
</div>
